import $ from "jquery";
import CustomTagEditable from "libs/jquery-editable/modules/custom.tag.editable";

class SelectEditable extends CustomTagEditable {
    element(settings, original) {
        const select = $('<select />');
        $(this).append(select);
        return select;
    }

    content(data, settings, original) {
        /* If it is string assume it is json. */
        const json = String === data.constructor ? JSON.parse(data) : data;
        for (const key in json) {
            if (!json.hasOwnProperty(key) || 'selected' === key) {
                continue;
            }
            const option = $('<option />').val(key).append(json[key]);
            $('select', this).append(option);
        }
        if (settings.width !== 'none') {
            $('select', this).width(settings.width);
        }
        /* Loop option again to set selected. IE needed this... */
        $('select', this).children().each(function () {
            if ($(this).val() === json['selected'] ||
                $(this).text() === $.trim(original.revert)) {
                $(this).attr('selected', 'selected');
            }
        });
    }
}

export default SelectEditable;
